// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import { Route, Switch, Redirect, RedirectProps, RouteProps } from 'react-router';

import Layout from '../components/common/Layout';

/* App Common Routes */
import { main as CommonMain, tabs as CommonTabs, redirects as CommonRedirects } from './common';

/* App Modules Routes */
import { routes as AlarmsRoutes, redirects as AlarmsRedirects } from './alarms';
import { routes as ConfigurationRoutes, redirects as ConfigurationRedirects } from './configuration';
import { routes as DashboardRoutes, redirects as DashboardRedirects } from './dashboard';
import { routes as ManagementRoutes, redirects as ManagementRedirects } from './management';
import { routes as SensorsRoutes, redirects as SensorsRedirects } from './sensors';

const renderRoutes = (items: RouteProps[]): JSX.Element[] => {
  return items.map((props: RouteProps) => {
    return <Route exact {...props} key={`path_${props.path}`} />;
  });
};

const renderRedirects = (items: RedirectProps[]): JSX.Element[] => {
  return items.map((props: RedirectProps) => {
    return (
      <Route exact path={props.from} key={`path_${props.from}_${props.to}`} render={(): JSX.Element => <Redirect to={props.to} />} />
    );
  });
};

const renderAllRoutes = (items: RouteProps[][]): JSX.Element[][] => {
  return items.map((item: RouteProps[]): JSX.Element[] => {
    return renderRoutes(item);
  });
};

const renderAllRedirects = (items: RedirectProps[][]): JSX.Element[][] => {
  return items.map((item: RedirectProps[]): JSX.Element[] => {
    return renderRedirects(item);
  });
};

const allRoutes: RouteProps[][] = [
  CommonMain,
  CommonTabs,
  AlarmsRoutes,
  ConfigurationRoutes,
  DashboardRoutes,
  ManagementRoutes,
  SensorsRoutes,
];

const allRedirects: RedirectProps[][] = [
  CommonRedirects,
  AlarmsRedirects,
  ConfigurationRedirects,
  DashboardRedirects,
  ManagementRedirects,
  SensorsRedirects,
];

const routes: JSX.Element = (
  <div>
    <Switch>
      {renderRoutes(CommonMain)}
      <Layout>
        {renderAllRedirects(allRedirects)}
        {renderAllRoutes(allRoutes)}
        <Route exact path="/" key="path_/" render={(): JSX.Element => <Redirect to="/landing" />} />
      </Layout>
    </Switch>
  </div>
);

export default routes;
